<template>
  <div
    @click="$emit('click', $event)"
    @mouseover="onMouseOver"
    @mouseleave="onMouseLeave"
    @focusin="onFocusIn"
    @focusout="onFocusOut"
  >
    <slot />
  </div>
</template>

<script>
export default {
  name: 'BaseHover',
  model: {
    prop: 'hover',
    event: 'hover',
  },
  props: {
    hover: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      isMouseOver: false,
      isFocusWithin: false,
    };
  },
  methods: {
    updateHover() {
      this.$emit('hover', this.isMouseOver || this.isFocusWithin);
    },
    onMouseOver() {
      this.isMouseOver = true;
      this.updateHover();
    },
    onMouseLeave() {
      this.isMouseOver = false;
      this.updateHover();
    },
    onFocusIn() {
      this.isFocusWithin = true;
      this.updateHover();
    },
    onFocusOut(event) {
      const nextFocusedElement = event && event.relatedTarget ? event.relatedTarget : null;
      if (!nextFocusedElement || !this.$el.contains(nextFocusedElement)) {
        this.isFocusWithin = false;
        this.updateHover();
      }
    },
  },
};
</script>

<style lang="scss" scoped>

</style>
